document.addEventListener("DOMContentLoaded", () => {
    const mobileToggle = document.getElementById("mobileToggle");
    const navLinks = document.getElementById("navLinks");
    const dropdownTriggers = document.querySelectorAll(".nav-link.has-dropdown");
    const allMenus = document.querySelectorAll(".dropdown");
    const navbar = document.querySelector(".nav");
    const hero = document.querySelector("[data-hero]");
    const blue_logo = document.querySelector(".logo-blue");
    const white_logo = document.querySelector(".logo-white");

    let lastScrollY = window.scrollY;

    function isMobile() {
        return window.innerWidth <= 991;
    }

    function positionDropdown(trigger, menu) {
        if (isMobile() || !menu) return;

        const triggerRect = trigger.getBoundingClientRect();
        const menuRect = menu.getBoundingClientRect();
        const menuWidth = menuRect.width || menu.offsetWidth || 300;
        const windowWidth = window.innerWidth;

        menu.style.top = `${Math.round(triggerRect.bottom + 8)}px`;

        // Align directly to the horizontal center of the nav item trigger
        let left = triggerRect.left + (triggerRect.width / 2) - (menuWidth / 2);

        // Boundary checks: keep safely inside viewport
        if (left + menuWidth > windowWidth - 20) {
            left = windowWidth - 20 - menuWidth;
        }
        if (left < 20) {
            left = 20;
        }

        menu.style.left = `${Math.round(left)}px`;
    }

    function closeAllMenus() {
        allMenus.forEach(menu => menu.classList.remove("is-open"));
        dropdownTriggers.forEach(trigger => trigger.classList.remove("is-open"));
    }

    function closeMobileNav() {
        if (!mobileToggle || !navLinks) return;
        mobileToggle.classList.remove("active");
        navLinks.classList.remove("active");
        document.body.classList.remove("nav-open");
        closeAllMenus();
    }

    if (mobileToggle && navLinks) {
        mobileToggle.addEventListener("click", () => {
            const isOpen = navLinks.classList.toggle("active");
            mobileToggle.classList.toggle("active", isOpen);
            document.body.classList.toggle("nav-open", isOpen);
            if (!isOpen) {
                closeAllMenus();
            }
        });

        navLinks.addEventListener("click", (e) => {
            const interactiveElement = e.target.closest("a:not(.has-dropdown), button:not(.has-dropdown)");
            if (interactiveElement && isMobile()) {
                closeMobileNav();
            }
        });
    }

    dropdownTriggers.forEach(trigger => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = trigger.getAttribute("data-target");
            const targetMenu = document.getElementById(targetId);

            if (targetMenu) {
                const isOpen = targetMenu.classList.contains("is-open");

                closeAllMenus();

                if (!isOpen) {
                    targetMenu.classList.add("is-open");
                    trigger.classList.add("is-open");
                    if (!isMobile()) {
                        positionDropdown(trigger, targetMenu);
                    }
                }
            }
        });
    });

    document.addEventListener("click", (e) => {
        if (isMobile()) return;

        const clickedTrigger = e.target.closest(".nav-link.has-dropdown");
        const clickedMenu = e.target.closest(".dropdown");

        if (!clickedTrigger && !clickedMenu) {
            closeAllMenus();
        }
    });

    window.addEventListener("resize", () => {
        if (!isMobile()) {
            closeMobileNav();
            allMenus.forEach(menu => {
                navLinks.appendChild(menu);
            });
            const openTrigger = document.querySelector(".nav-link.has-dropdown.is-open");
            if (openTrigger) {
                const openMenu = document.getElementById(openTrigger.getAttribute("data-target"));
                if (openMenu) positionDropdown(openTrigger, openMenu);
            }
        } else {
            allMenus.forEach(menu => {
                menu.style.left = "";
                menu.style.top = "";
            });
            dropdownTriggers.forEach(trigger => {
                const targetId = trigger.getAttribute("data-target");
                const targetMenu = document.getElementById(targetId);
                if (targetMenu && trigger.nextElementSibling !== targetMenu) {
                    trigger.after(targetMenu);
                }
            });
        }
    });

    if (isMobile()) {
        dropdownTriggers.forEach(trigger => {
            const targetId = trigger.getAttribute("data-target");
            const targetMenu = document.getElementById(targetId);
            if (targetMenu) {
                trigger.after(targetMenu);
            }
        });
    }

    const update_nav = () => {
        if (!navbar) return;

        const isLight = navbar.classList.contains("navbar-light");
        const currentScrollY = window.scrollY;

        if (currentScrollY > 100) {
            if (currentScrollY > lastScrollY && !document.body.classList.contains("nav-open")) {
                navbar.classList.add("nav-hidden");
            } else {
                navbar.classList.remove("nav-hidden");
            }
        } else {
            navbar.classList.remove("nav-hidden");
        }
        lastScrollY = currentScrollY;

        // On navbar-light pages (no dark hero), 'scrolled' fires after 20px
        // On dark hero pages (home), wait until past hero section
        const scrollThreshold = isLight ? 20 : (hero ? hero.offsetHeight - 50 : 50);
        const is_scrolled = currentScrollY > scrollThreshold;
        navbar.classList.toggle("scrolled", is_scrolled);

        if (!white_logo || isLight) {
            if (blue_logo) blue_logo.style.display = "block";
            if (white_logo) white_logo.style.display = "none";
        } else {
            if (blue_logo) blue_logo.style.display = is_scrolled ? "block" : "none";
            if (white_logo) white_logo.style.display = is_scrolled ? "none" : "block";
        }
        const openTrigger = document.querySelector(".nav-link.has-dropdown.is-open");
        if (openTrigger) {
            if (navbar.classList.contains("nav-hidden")) {
                closeAllMenus();
            } else if (!isMobile()) {
                const triggerRect = openTrigger.getBoundingClientRect();
                if (triggerRect.bottom < 0 || triggerRect.top > window.innerHeight) {
                    closeAllMenus();
                } else {
                    const openMenu = document.getElementById(openTrigger.getAttribute("data-target"));
                    if (openMenu) positionDropdown(openTrigger, openMenu);
                }
            }
        }
    };

    update_nav();
    window.addEventListener("scroll", update_nav, { passive: true });
});